import assert from 'assert';
import router from 'next/router';
import qs from 'qs';
import {IS_CLIENT_SIDE} from './constants';

/**
 * 현재 페이지(pathname)에 queryString만 변경하여 router.push 합니다.
 */
export function pushToRouter(queryStringMap: {[index: string]: any}): void {
  assert(IS_CLIENT_SIDE);

  router.push(`${location.pathname}?${qs.stringify(queryStringMap)}`);
}
